import type { AxiosError, AxiosResponse } from "axios";
import axios from "axios";
import { createQuery } from "react-query-kit";
import SubGroupModel from "../../models/products/subgroup-model";

import { API_END_POINT } from "../../constants";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";

const url = getEndPoint(API_END_POINT.PRODUCT) +"/api/SubGroup/GetAllSubGroup";
export const useGetSubGroups = createQuery<
SubGroupModel[],
  null,
  AxiosError
>({
  queryKey: ["keySubGrouplist"],
  fetcher: (params) =>
        getDataWithToken<any>(url).then((response) => response.data?.result || console.log(response)),
    
    // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
  refetchOnWindowFocus: false,
});
